module.exports = __webpack_public_path__ + "static/media/iv_no_rewards.248f95ec.svg";